module.exports = __webpack_public_path__ + "img/pause.be138dbe.svg";